import { Pipe, PipeTransform } from '@angular/core';

import { isProductActive } from 'src/app/constants/constants';

@Pipe({ name: 'isProductActive' })
export class IsProductActivePipe implements PipeTransform {
  transform(
    isMaster: boolean,
    customerAlias: any,
    customerDocument: any,
    hasUserWebAccess: boolean,
    userMetaData: any,
    productType: string,
    productId?: number,
    alsoInThePast?: boolean,
    alsoOutOfSeason?: boolean,
    isUserAdminMode?: boolean
  ) {
    return isProductActive(
      isMaster,
      customerAlias,
      customerDocument,
      hasUserWebAccess,
      userMetaData,
      productType,
      productId,
      alsoInThePast,
      alsoOutOfSeason,
      isUserAdminMode
    );
  }
}
